import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/PageLayout';

// Blog post data
const golfTips = [
  {
    id: 1,
    slug: 'choosing-the-best-putter',
    title: 'Choosing the Best Putter for Your Game',
    date: 'April 12, 2025',
    image: 'https://images.pexels.com/photos/6974/golf-green-putting-hole.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: 'Finding the right putter can dramatically improve your short game. Learn how to select a putter that matches your stroke style and preferences.',
    author: 'Mike Johnson',
    authorTitle: 'PGA Professional'
  },
  {
    id: 2,
    slug: 'improving-your-chipping-game',
    title: 'Master Your Chipping: Tips for Around the Green',
    date: 'April 5, 2025',
    image: 'https://images.pexels.com/photos/6578275/pexels-photo-6578275.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: 'Struggling with your short game? These expert chipping techniques will help you save strokes and build confidence around the green.',
    author: 'Sarah Williams',
    authorTitle: 'Golf Instructor'
  },
  {
    id: 3,
    slug: 'driving-distance-secrets',
    title: 'Add 20 Yards to Your Drive: Distance Secrets',
    date: 'March 29, 2025',
    image: 'https://images.pexels.com/photos/6859552/pexels-photo-6859552.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: 'Learn the techniques professional golfers use to maximize driving distance without sacrificing accuracy or consistency.',
    author: 'Tom Richards',
    authorTitle: 'Power Driving Specialist'
  },
  {
    id: 4,
    slug: 'bunker-shot-fundamentals',
    title: 'Bunker Shot Fundamentals: Escape the Sand Every Time',
    date: 'March 22, 2025',
    image: 'https://images.pexels.com/photos/6578391/pexels-photo-6578391.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: 'Transform your bunker play from a weakness to a strength with these simple adjustments to your setup and technique.',
    author: 'Lisa Chen',
    authorTitle: 'Short Game Coach'
  },
  {
    id: 5,
    slug: 'mental-game-strategies',
    title: 'Mental Game Strategies for Lower Scores',
    date: 'March 15, 2025',
    image: 'https://images.pexels.com/photos/6975/golf-tee-golf-ball-golf-club.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: 'Improve your focus, manage pressure, and develop a winning mindset with these proven mental techniques from sports psychologists.',
    author: 'Dr. James Wilson',
    authorTitle: 'Sports Psychology Consultant'
  },
  {
    id: 6,
    slug: 'putting-stroke-perfection',
    title: 'Perfect Your Putting Stroke: Drills for Consistency',
    date: 'March 8, 2025',
    image: 'https://images.pexels.com/photos/6574926/pexels-photo-6574926.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: 'Eliminate the three-putts and develop a repeatable stroke with these practice drills you can do anywhere - even at home!',
    author: 'Robert Taylor',
    authorTitle: 'Putting Specialist'
  }
];

/**
 * Golf Tips Blog Page component
 */
const GolfTipsPage: React.FC = () => {
  return (
    <PageLayout 
      title="Golf Tips & Advice" 
      subtitle="Weekly insights from our golf professionals to help improve your game"
      backgroundImage="https://images.pexels.com/photos/6571791/pexels-photo-6571791.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    >
      <section>
        <h2>Latest Tips</h2>
        <p className="intro-text">
          Welcome to our weekly golf tips series where our PGA professionals share their expertise to help you 
          improve every aspect of your game. From driving to putting, mental game to course management, 
          we've got you covered.
        </p>
        
        <div className="blog-posts">
          {golfTips.map(post => (
            <div key={post.id} className="blog-post-card">
              <div 
                className="blog-post-image"
                style={{ backgroundImage: `url(${post.image})` }}
              ></div>
              <div className="blog-post-content">
                <div className="blog-post-date">{post.date} | By {post.author}</div>
                <h3 className="blog-post-title">{post.title}</h3>
                <p className="blog-post-excerpt">{post.excerpt}</p>
                <Link to={`/golf-tips/${post.slug}`} className="blog-post-link">
                  Read Full Article →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
      
      <section style={{ marginTop: '3rem' }}>
        <h2>Subscribe to Weekly Tips</h2>
        <div className="content-card">
          <p>
            Get our latest golf tips and advice delivered straight to your inbox every week. 
            Never miss an opportunity to improve your game!
          </p>
          <form className="contact-form" style={{ padding: '0', boxShadow: 'none' }}>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" placeholder="your.email@example.com" />
            </div>
            <button type="submit" className="form-submit">Subscribe</button>
          </form>
        </div>
      </section>
    </PageLayout>
  );
};

export default GolfTipsPage;
